import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import i18n from 'modules/core/lib/i18n'

import type CustomFields from 'modules/custom_resources/store/collections/customFields/fields'
import Question from 'modules/reviews/components/WriteResponse/Question'

type QuestionProps = React.ComponentProps<typeof Question>
interface Props {
  formsWithoutCategoryWithScoreType: Form[]
  customFieldsWithoutCategoryWithScoreType: CustomFields
  optionsWithoutCategoryWithScoreType: Record<string, QuestionProps['options']>
  isResponseValues?: boolean
  canReview?: boolean
}

const QuestionsWithoutCategoryWithScoreType = ({
  formsWithoutCategoryWithScoreType,
  customFieldsWithoutCategoryWithScoreType,
  optionsWithoutCategoryWithScoreType,
  isResponseValues,
  canReview,
}: Props) => {
  return (
    <Box
      border={{
        top: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
    >
      <Box gap="s48" paddingTop="s24" paddingX="s24">
        <Text size="300" color="grey1000" weight="medium">
          {i18n.t('surveys.form.question_categories.score_type_question')}
        </Text>
      </Box>
      <Box gap="s48" padding="s24">
        {formsWithoutCategoryWithScoreType.map((form: Form, index: number) => {
          const field = customFieldsWithoutCategoryWithScoreType.get(
            Number(form.get('field_id').value)
          )

          if (!field) {
            return null
          }
          field.attributes.position = null

          return (
            <Box key={form.get('name').value} flexDirection="row" gap="s24" flexGrow>
              <Question
                key={index}
                fieldName={form.get('name').value}
                fieldType={form.get('field_type').value}
                formField={form.get('value')}
                mandatory={form.get('mandatory').value}
                minValue={+form.get('min_value').value} // +null => 0
                maxValue={+form.get('max_value').value} // +null => 0
                options={optionsWithoutCategoryWithScoreType[field.attributes.id] ?? []}
                readonly={isResponseValues || !canReview}
                position={index + 1}
              />
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

export default QuestionsWithoutCategoryWithScoreType
